import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

const useComponentShortcuts = ({
    toggleModal,
    createComponent,
}: {
    toggleModal?: () => void;
    createComponent?: () => void;
}) => {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || e.shiftKey || isModalOpen) {
                return;
            }

            if (!isCtrlKey(e)) {
                switch (e.code) {
                    case 'KeyP': {
                        if (toggleModal) {
                            toggleModal();
                        }

                        break;
                    }

                    default:
                        break;
                }
            } else {
                switch (e.code) {
                    case 'KeyP': {
                        e.preventDefault();

                        if (createComponent) {
                            createComponent();
                        }

                        break;
                    }

                    default:
                        break;
                }
            }
        },
        [toggleModal, createComponent, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useComponentShortcuts;
